import { render, staticRenderFns } from "./OpenFinanceDashboard.vue?vue&type=template&id=170bf37e"
import script from "./OpenFinanceDashboard.vue?vue&type=script&lang=js"
export * from "./OpenFinanceDashboard.vue?vue&type=script&lang=js"
import style0 from "./OpenFinanceDashboard.vue?vue&type=style&index=0&id=170bf37e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170bf37e')) {
      api.createRecord('170bf37e', component.options)
    } else {
      api.reload('170bf37e', component.options)
    }
    module.hot.accept("./OpenFinanceDashboard.vue?vue&type=template&id=170bf37e", function () {
      api.rerender('170bf37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OpenFinanceDashboard.vue"
export default component.exports